/**
 * Featured blocks carousel functionality
 * Creates responsive sliders for featured content blocks and promotional sections
 * Handles multiple breakpoints for optimal display across devices
 */

(async () => {

  if (!customElements.get('featured-blocks-swiper')) {

    const { default: Swiper, Navigation, Pagination, Scrollbar, Autoplay } = await import("swiper");

    Swiper.use([
      Navigation,
      Pagination,
      Scrollbar,
      Autoplay
    ]);

    class FeaturedBlocks extends HTMLElement {
      constructor() {
        super();
        this.swiperElement = this.querySelector('[data-swiper-featured-blocks]');
        this.swiperOptions = {
          loop: false,
          autoplay: false,
          slidesPerView: 1.5,
          direction: 'horizontal',
          breakpoints: {
            375: {
              slidesPerView: 1.5
            },
            768: {
              slidesPerView: 3
            },
            1200: {
              slidesPerView: 4
            }
          }
        }

        // Check if we have extra options on the HTML
        if (this && this.dataset && this.dataset.options) {
          const jsonOptions = JSON.parse(this.dataset.options);
          if (jsonOptions) {
            this.swiperOptions = {
              ...this.swiperOptions,
              ...jsonOptions
            };
          }
        }

        // re-init slider when Theme Editor is active
        if (Shopify.designMode && this.swiperInstance) {
          window.addEventListener('shopify:section:load', () => {
            this.swiperInstance.update();
          });
        }
        this.init();
      }

      init() {
        this.swiperInstance = new Swiper(this.swiperElement, this.swiperOptions);
      }

    }

    window.FeaturedBlocks = FeaturedBlocks;

    customElements.define('featured-blocks-swiper', FeaturedBlocks);

  }

})();
